'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment/moment');

var _moment2 = _interopRequireDefault(_moment);

var _string_utility = require('../../../packages/common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _single_date_picker_wrapper = require('./global_components/single_date_picker_wrapper');

var _single_date_picker_wrapper2 = _interopRequireDefault(_single_date_picker_wrapper);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

var _button = require('./global_components/button');

var _button2 = _interopRequireDefault(_button);

var _ramda = require('ramda');

var _tracking_utility = require('../../../packages/common-utilities/src/tracking_utility');

var _date_range_dropdown = require('./global_components/date_range_dropdown');

var _date_range_dropdown2 = _interopRequireDefault(_date_range_dropdown);

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _click_or_escape_outside = require('./click_or_escape_outside');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIS_RATES_START_DATE = "02/04/2022";
var setTooltipWrapper = function setTooltipWrapper(text) {
  return _react2.default.createElement(
    'span',
    { 'data-testid': 'tooltip-error',
      id: 'tooltip-error',
      className: 'caption font-light font-extreme-red' },
    text
  );
};
var getDateFromObject = function getDateFromObject(data) {
  var pathToDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "date";
  return (0, _ramda.path)([pathToDate], data);
};

var BelgianTisRatesCard = function (_React$Component) {
  _inherits(BelgianTisRatesCard, _React$Component);

  function BelgianTisRatesCard(props) {
    _classCallCheck(this, BelgianTisRatesCard);

    var _this = _possibleConstructorReturn(this, (BelgianTisRatesCard.__proto__ || Object.getPrototypeOf(BelgianTisRatesCard)).call(this, props));

    _this.renderToolTipErrorMessage = function (elementId, errorKey) {
      var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tooltipMessage = null;
      var values = {
        startDate: _date_formatter2.default.getLocalFormattedDate(getDateFromObject(_this.props.historicalNAVList[0])),
        endDate: _date_formatter2.default.getLocalFormattedDate(getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList)))
      };
      if (errorKey === 'pdp-historical-chart-error-message-out-of-range') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[4], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-prior-to-to-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[0], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-from-date-same-as-to-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[2], errorKey);
      } else if (errorKey === 'pdp-historical-chart-error-message-prior-to-from-Date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[1], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-to-date-same-as-from-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[3], errorKey);
      }
      tooltipMessage = setTooltipWrapper(tooltipMessage);
      var el = document.getElementById(elementId);
      var elHeight = el.offsetHeight;
      var elWidth = el.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var offsetArrowHeight = 4;
      var elPadding = 10;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var toolTipWidth = el.offsetWidth;

      var elOffset = (0, _ramda.mergeDeepRight)({
        top: elRect.top + docTop + arrowHeight + elHeight - offsetArrowHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - elPadding + (elRect.right - elRect.left) / 8,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipWidth,
        showCrossIcon: false
      }, additionalProps);

      _this.setState({
        error: "extreme",
        errorId: elementId
      });
      elementId === _this.props.id + '-from-date' ? _this.refs.from_dropdown_ref.handleOpen() : _this.refs.to_dropdown_ref.handleOpen();
      _this.props.tooltip.openTooltip(elOffset, null, tooltipMessage, false);
    };

    _this.setRef = _this.setRef.bind(_this);
    _this.renderCustomDatePickers = _this.renderCustomDatePickers.bind(_this);
    _this.renderToolTipErrorMessage = _this.renderToolTipErrorMessage.bind(_this);
    _this.resetErrorState = _this.resetErrorState.bind(_this);
    _this.onChangeFromDate = _this.onChangeFromDate.bind(_this);
    _this.onChangeToDate = _this.onChangeToDate.bind(_this);
    _this.setDateFilter = _this.setDateFilter.bind(_this);
    _this.dateRangeItems = _this.dateRangeItems.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.renderDateRangeDropdown = _this.renderDateRangeDropdown.bind(_this);
    _this.setCustomDateRangeDropdown = _this.setCustomDateRangeDropdown.bind(_this);

    var toDate = getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList));
    var fromDate = _moment2.default.utc(toDate).subtract(12, 'months');

    toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(toDate, "YYYY-MM-DD"));
    fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(fromDate, "YYYY-MM-DD"));

    _this.maxDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(_this.props.historicalNAVList)), "YYYY-MM-DD"));
    _this.minDate = (0, _moment2.default)((0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(_this.props.historicalNAVList[0]), "YYYY-MM-DD")));

    _this.state = {
      fromDate: fromDate,
      validFromDate: fromDate,
      toDate: toDate,
      validToDate: toDate,
      errorMessage: '',
      selectedDateOption: "Last 1 year",
      selectedDateOptionTranslateKey: "dropdown-last-1-year"
    };

    _this.errorMessages = ["From Date has to be less than to date.", "To Date cannot be less than from date", "From Date cannot be same as To date", "To Date cannot be same as From date", _this.defaultOutOfRangeErrorMessage()];
    return _this;
  }

  _createClass(BelgianTisRatesCard, [{
    key: 'renderCustomDatePickers',
    value: function renderCustomDatePickers(toDate, fromDate) {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'display-inline' },
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-0 margin-right-10 text-top', 'data-testid': 'from-date-picker' },
          _react2.default.createElement(
            'div',
            {
              className: 'margin-bottom-5 tag-2', role: 'label', id: 'From' },
            _string_utility2.default.renderFormattedLabel("FROM", "pdp-perf-chart-date-from-label")
          ),
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: 'from-dropdown',
                ref: 'from_dropdown_ref',
                key: 'FROM',
                onClose: function onClose() {
                  _this2.resetErrorState();
                }
              },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                date: fromDate,
                minDate: this.minDate,
                maxDate: (0, _moment2.default)(this.maxDate).format("YYYY-MM-DD"),
                id: this.props.id + "-from-date",
                dateFormat: 'DD/MM/YYYY',
                ariaLabel: "From Date Belgium TIS Rates",
                onChangeDate: this.onChangeFromDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this2.setCustomDateRangeDropdown();
                },
                renderMonthElement: this.getMonthAndYearDropdowns()
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-0 margin-right-10 text-top', 'data-testid': 'to-date-picker' },
          _react2.default.createElement(
            'div',
            {
              className: 'margin-bottom-5 tag-2', role: 'label', id: 'To' },
            _string_utility2.default.renderFormattedLabel("TO", "pdp-perf-chart-date-to-label")
          ),
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: 'to-dropdown',
                ref: 'to_dropdown_ref',
                key: 'TO',
                onClose: function onClose() {
                  _this2.resetErrorState();
                }
              },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                date: toDate,
                id: this.props.id + "-to-date",
                dateFormat: 'DD/MM/YYYY',
                ariaLabel: "To Date Belgian Tis Rates",
                minDate: (0, _moment2.default)(this.minDate).add(1, 'day').format("YYYY-MM-DD"),
                maxDate: (0, _moment2.default)(this.maxDate).add(1, 'day'),
                onChangeDate: this.onChangeToDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this2.setCustomDateRangeDropdown();
                },
                renderMonthElement: this.getMonthAndYearDropdowns()
              })
            )
          )
        )
      );
    }
  }, {
    key: 'resetErrorState',
    value: function resetErrorState() {
      if (this.state.error === "extreme") {
        this.props.tooltip.closeTooltip();
        this.setState({
          error: "moderate",
          errorId: null,
          fromDate: !(0, _ramda.isEmpty)(this.state.errorMessage) ? this.state.validFromDate : this.state.fromDate,
          toDate: !(0, _ramda.isEmpty)(this.state.errorMessage) ? this.state.validToDate : this.state.toDate,
          errorMessage: ''
        });
      }
    }
  }, {
    key: 'onChangeFromDate',
    value: function onChangeFromDate(fromDate) {
      var validToDate = this.state.validToDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(fromDate) || fromDate.startOf('day').isBefore(this.minDate, "YYYY-MM-DD")) {
        this.handleOutOfRangeDate(this.props.id + "-from-date");
        return false;
      }

      if (fromDate.isAfter(validToDate)) {
        errorMessage = "pdp-historical-chart-error-message-prior-to-to-date";
      } else if (fromDate.isSame(validToDate)) {
        errorMessage = "pdp-historical-chart-error-message-from-date-same-as-to-date";
      }
      this.validateDate(errorMessage, fromDate, validToDate, this.props.id + "-from-date");
    }
  }, {
    key: 'onChangeToDate',
    value: function onChangeToDate(toDate) {
      var validFromDate = this.state.validFromDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(toDate) || toDate.startOf('day').isAfter(this.maxDate)) {
        this.handleOutOfRangeDate(this.props.id + "-to-date");
        return false;
      }

      if (toDate.isBefore(validFromDate, "YYYY-MM-DD")) {
        errorMessage = "pdp-historical-chart-error-message-prior-to-from-Date";
      } else if (toDate.isSame(validFromDate, "day") && toDate.isSame(validFromDate, "month") && toDate.isSame(validFromDate, "year")) {
        errorMessage = "pdp-historical-chart-error-message-to-date-same-as-from-date";
      }

      this.validateDate(errorMessage, validFromDate, toDate, this.props.id + "-to-date");
    }
  }, {
    key: 'validateDate',
    value: function validateDate(errorMessage, fromDate, toDate, label) {
      var _this3 = this;

      var filteredData = void 0;
      var validDateRange = (0, _ramda.isEmpty)(errorMessage);

      if (validDateRange) {
        filteredData = this.setFilteredData(fromDate, toDate);
        this.setState({
          fromDate: fromDate,
          validFromDate: fromDate,
          toDate: toDate,
          validToDate: toDate,
          filteredData: filteredData,
          errorMessage: errorMessage
        }, this.props.tooltip.closeTooltip());
      } else {
        this.setState({
          errorMessage: errorMessage
        }, function () {
          return _this3.renderToolTipErrorMessage(label, errorMessage, {
            toolTipWidth: "254px",
            toolTipContentWidth: "100%"
          });
        });
      }
    }
  }, {
    key: 'setFilteredData',
    value: function setFilteredData(fromDate, toDate) {

      var normalizedFromDate = _moment2.default.utc((0, _moment2.default)(fromDate.toDate()).startOf('date'));
      var normalizedToDate = _moment2.default.utc((0, _moment2.default)(toDate.toDate()).endOf('date'));

      return _collection_utility.CollectionUtility.filter(this.props.historicalNAVList, function (performance) {
        return _moment2.default.utc((0, _moment2.default)(performance.date)).isBetween(normalizedFromDate, normalizedToDate, null, '[]');
      });
    }
  }, {
    key: 'getMonthAndYearDropdowns',
    value: function getMonthAndYearDropdowns() {
      var _this4 = this;

      var years = [];
      for (var i = this.minDate.year(); i <= this.maxDate.year(); i++) {
        years.push(_react2.default.createElement(
          'option',
          { value: i, 'data-testId': this.props.id + '-year-dropdown-' + i,
            id: 'belgian-tis-rates-card-year-dropdown-' + i },
          i
        ));
      }

      return function (_ref) {
        var month = _ref.month,
            onMonthSelect = _ref.onMonthSelect,
            onYearSelect = _ref.onYearSelect;
        return _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          _react2.default.createElement(
            'div',
            { 'data-testId': _this4.props.id + '-month-dropdown', id: 'belgian-tis-rates-card-month-dropdown' },
            _react2.default.createElement(
              'select',
              {
                value: month.month(),
                onChange: function onChange(e) {
                  onMonthSelect(month, e.target.value);
                }
              },
              _moment2.default.monthsShort().map(function (label, value) {
                return _react2.default.createElement(
                  'option',
                  {
                    'data-testId': _this4.props.id + '-month-dropdown-' + value,
                    id: 'belgian-tis-rates-card-month-dropdown-' + value,
                    value: value },
                  label
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { 'data-testId': _this4.props.id + '-year-dropdown', id: 'belgian-tis-rates-card-year-dropdown' },
            _react2.default.createElement(
              'select',
              {
                value: month.year(),
                onChange: function onChange(e) {
                  onYearSelect(month, e.target.value);
                }
              },
              years
            )
          )
        );
      };
    }
  }, {
    key: 'handleOutOfRangeDate',
    value: function handleOutOfRangeDate(label) {
      var _this5 = this;

      this.setState({
        fromDate: label === this.props.id + '-from-date' ? null : this.state.fromDate,
        toDate: label === this.props.id + '-to-date' ? null : this.state.toDate,
        errorMessage: "pdp-historical-chart-error-message-out-of-range"
      }, function () {
        return _this5.renderToolTipErrorMessage(label, "pdp-historical-chart-error-message-out-of-range", {
          toolTipWidth: "254px",
          toolTipContentWidth: "100%"
        });
      });
    }
  }, {
    key: 'trackDataDownload',
    value: function trackDataDownload() {
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": 'Belgian Tis Rates',
        "eventLabel": "download data"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: 'setRef',
    value: function setRef(refId) {
      var _this6 = this;

      return function (el) {
        return _this6[refId] = el;
      };
    }
  }, {
    key: 'renderDateRangeDropdown',
    value: function renderDateRangeDropdown() {
      return _react2.default.createElement(_date_range_dropdown2.default, {
        dateRangeItems: this.dateRangeItems,
        setRef: this.setRef,
        parentProps: this.props,
        state: this.state
      });
    }
  }, {
    key: 'dateRangeItems',
    value: function dateRangeItems() {
      var items = [];
      items.push(this.generateDateRangeRow("12", 'Last 1 year', 'dropdown-last-1-year', 0));
      items.push(this.generateDateRangeRow("custom", "Custom Date Range", "dropdown-custom-date-range", 1));

      return items;
    }
  }, {
    key: 'generateDateRangeRow',
    value: function generateDateRangeRow(value, displayValue, translationKey, key) {
      var _this7 = this;

      this[value + 'dropdown'] = _react2.default.createRef();
      var isLastElement = value === "custom";
      return _react2.default.createElement(
        'div',
        { key: key,
          tabIndex: 0,
          'data-option-value': value,
          'data-translation-key': translationKey,
          'data-display-value': displayValue,
          ref: this[value + 'dropdown'],
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleDropdownEvents(_this7, event, '#card-component-' + _this7.props.id + ' #dateRangeFilter', value + 'dropdown', '0dropdown', isLastElement, function () {
              return _this7.setDateFilter(event);
            });
          },
          onClick: this.setDateFilter, className: 'dropdown-list-item', role: 'option' },
        _react2.default.createElement(
          'span',
          { className: 'font-light caption', 'data-option-value': value,
            'data-translation-key': translationKey, 'data-display-value': displayValue },
          _string_utility2.default.renderFormattedLabel(displayValue, translationKey)
        )
      );
    }
  }, {
    key: 'setDateFilter',
    value: function setDateFilter(event) {
      var _this8 = this;

      var toDate = void 0;
      var fromDate = void 0;

      var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;

      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": "pdp",
        "eventAction": "historical price",
        "eventLabel": target.getAttribute("data-display-value")
      });

      if (target.getAttribute("data-option-value") === 'custom') {
        toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(new Date()), "YYYY-MM-DD");
        fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(new Date(TIS_RATES_START_DATE), "YYYY-MM-DD"));

        this.setState({
          selectedDateOption: target.getAttribute("data-display-value"),
          selectedDateOptionTranslateKey: target.getAttribute("data-translation-key"),
          selectedDateOptionValue: "custom",
          toDate: toDate,
          validToDate: toDate,
          fromDate: fromDate,
          validFromDate: fromDate
        });
      } else {
        var dateOption = Number(target.getAttribute("data-option-value"));
        toDate = getDateFromObject((0, _ramda.last)(this.props.historicalNAVList));
        fromDate = _moment2.default.utc(toDate).subtract(dateOption, 'months');

        toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(toDate, "YYYY-MM-DD"));
        fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(fromDate, "YYYY-MM-DD"));

        this.setState({
          selectedDateOptionValue: dateOption,
          selectedDateOption: target.getAttribute("data-display-value"),
          selectedDateOptionTranslateKey: target.getAttribute("data-translation-key"),
          toDate: toDate,
          validToDate: toDate,
          fromDate: fromDate,
          validFromDate: fromDate,
          error: "moderate",
          errorId: null
        }, function () {
          _this8.props.tooltip.closeTooltip();
        });
      }
    }
  }, {
    key: 'setCustomDateRangeDropdown',
    value: function setCustomDateRangeDropdown() {
      this['dropdown-label-dateRange'].text = 'Custom Date Range';
      this.setState({
        selectedDateOption: 'Custom Date Range',
        selectedDateOptionTranslateKey: 'dropdown-custom-date-range',
        selectedDateOptionValue: 'custom'
      });
    }
  }, {
    key: 'defaultOutOfRangeErrorMessage',
    value: function defaultOutOfRangeErrorMessage() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.historicalNAVList)) {
        return "Please enter a date within the date range";
      }
      return "Please enter a date within the date range " + getDateFromObject(this.props.historicalNAVList[0]) + " - " + getDateFromObject((0, _ramda.last)(this.props.historicalNAVList)) + ".";
    }
  }, {
    key: 'render',
    value: function render() {
      var fromDateQuery = (0, _ramda.isNil)(this.state.fromDate) ? "" : this.state.fromDate.format().replace(/T.+/g, "");
      var toDateQuery = (0, _ramda.isNil)(this.state.toDate) ? "" : this.state.toDate.format().replace(/T.+/g, "");
      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=' + this.props.downloadType + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale() + '&fromDate=' + fromDateQuery + '&toDate=' + toDateQuery);
      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel('Belgian Taxable Income Per Share (TIS)', 'pdp-historical-belgian-tis-rates-card-title'),
          headerTitleId: "belgianTisRatesCard",
          headerTitleLabel: "",
          headerLabel: "",
          breakpoint: this.props.breakpoint,
          dataTest: 'belgian-tis-rates-card',
          allowOverflow: true
        },
        _react2.default.createElement(
          'div',
          { className: 'container width-percent-100 padding-all-0' },
          _react2.default.createElement(
            'div',
            { className: 'title font-normal tag' },
            _string_utility2.default.renderFormattedLabel("Select dates", "pdp-historical-belgian-tis-rates-card-subheader")
          ),
          _react2.default.createElement(
            'div',
            { 'data-testid': 'customDateRangeComponent', className: 'font-regular tag' },
            this.renderDateRangeDropdown(),
            this.renderCustomDatePickers(this.state.toDate, this.state.fromDate)
          ),
          _react2.default.createElement(_button2.default, {
            role: this.props.role,
            dataTest: "download-data",
            downloadURL: excelServiceURL,
            dataTestLink: this.props.id + '-excel-download',
            text: _string_utility2.default.renderFormattedLabel("DOWNLOAD DATA", "pdp-download-data"),
            widerTopMargin: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HISTORICAL_CHART_DOWNLOAD_BUTTON_WITH_WIDER_TOP_MARGIN'),
            additionalClassName: "mobile-full-width",
            callBack: this.trackDataDownload,
            ariaLabel: 'Download Data for Belgian Taxable Income Per Share (TIS)'
          }),
          _react2.default.createElement(
            'div',
            { 'data-testid': 'belgian-tis-rates-disclosure',
              className: 'disclosure display-inline-block disclaimer margin-top-1'
            },
            _string_utility2.default.renderFormattedHTMLLabel('', 'pdp-historical-belgian-tis-rates-card-disclosure')
          )
        )
      );
    }
  }]);

  return BelgianTisRatesCard;
}(_react2.default.Component);

exports.default = BelgianTisRatesCard;